import "./ConversationLogVariable.css"
import TextInput from "/src/components/UI/TextField/TextInput";
const ConversationLogVariable = ({ variable }) => {

    return (
        <div className="conversation_log_container_variable">
            
            <div className="conversation_log_name_variable" title={variable[0]}> {[variable[0]]} </div> <TextInput className={"conversation_log_value_variable"} defaultValue={variable[1]} disabled/>
        </div>
    );
};

export default ConversationLogVariable;